// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1ejG7","similarBtnCta":"_3Ac8N","sliderWrapper":"_17Q8V"};